export const types = {
  GET_TRANSLATION_CACHE: '@/GET_TRANSLATION_CACHE',
  GET_TRANSLATION_CACHE_SUCCESS: '@/GET_TRANSLATION_CACHE_SUCCESS'
};
